const { mapActions, mapGetters } = require("vuex");
const { getObjectValue } = require("@root/helpers");
const pathToRegexp = require("path-to-regexp");

module.exports = {
	methods: {
		getObjectValue
	}
};

let fillHeight = {
	computed: {
		fillHeight() {
			const path = this.$route.path;
			const isSummary =
				pathToRegexp("/configurator/(.+)/summary").exec(path) !== null;

			if (isSummary) {
				return false;
			}

			const isConfigurator =
				pathToRegexp("/configurator/(.*)?").exec(path) !== null;
			const isOrders = pathToRegexp("/orders/(.*)?").exec(path) !== null;

			const fillHeight = isConfigurator || isOrders;
			if (this.$vuetify.breakpoint.width < 1024 && fillHeight) {
				return false;
			}

			return true;
		}
	}
};

module.exports.fillHeight = fillHeight;

let documents = {
	computed: {
		steps() {
			let routes = this.getObjectValue(
				"options.routes",
				this.$router,
				[]
			);

			let builderRoutes = getObjectValue(
				"children",
				routes.find(
					route =>
						this.getObjectValue("name", route, false) === "builder"
				),
				[]
			);

			return builderRoutes.reduce(
				(carry, route) => {
					if (
						this.getObjectValue(
							"meta.navigation",
							route,
							true,
							true
						)
					) {
						carry.push(route);
					}

					return carry;
				},
				[null]
			);
		}
	},

	methods: {
		getBuilderUrl(document, step = null, additionalParams = {}) {
			let route = this.steps.find(
				item =>
					this.getObjectValue("meta.step", item) ===
					(step || document.step)
			);
			let params = _.merge({ number: document.number }, additionalParams);
			let path = route.path;

			if (this.getObjectValue("number", params, null) === "create") {
				path = path.replace(
					`number(${window.Spark.number_format})`,
					"number(create)"
				);
			}

			const toPath = pathToRegexp.compile(path);

			return toPath(params);
		}
	}
};

module.exports.documents = documents;

const quoteBuilder = {
	mixins: [documents, fillHeight],

	props: {
		number: {
			default: null
		},

		document: {
			default() {
				return {
					proposal_date: "",
					send_reminder_on: ""
				};
			}
		}
	},

	computed: {
		...mapGetters("documents", {
			CURRENT_DOCUMENT: "currentDocument",
			CURRENT_DOCUMENT_BY_ID: "currentDocumentById"
		}),

		isProposal() {
			if (this.isCreate) {
				return false;
			}

			return !this.isQuote;
		},

		isQuote() {
			return (
				this.getObjectValue("currentDocument.saved_at", this, null) ===
				null
			);
		},

		isOrder() {
			return (
				this.getObjectValue(
					"currentDocument.ordered_at",
					this,
					null
				) !== null
			);
		},

		isCreate() {
			return this.number === "create";
		},

		currentDocument() {
			if (this.isCreate) {
				return {
					number: "Welcome to the",
					name: "Product Configurator",
					proposal_date: "",
					send_reminder_on: ""
				};
			}

			if (this.getObjectValue("document.number", this, false)) {
				return this.document;
			}

			return this.CURRENT_DOCUMENT(this.number);
		},

		preventStepUpdate() {
			return this.getObjectValue("hasErrors", this, false);
		}
	},

	methods: {
		...mapActions("documents", {
			UPDATE_DOCUMENT_STEP: "updateDocumentStep",
			CREATE_REVISION: "createRevision"
		}),

		updateStepAndNavigate(step) {
			this.UPDATE_DOCUMENT_STEP({
				document: this.document,
				step
			}).then(data => {
				this.$router.push({
					path: this.getBuilderUrl(this.document, step)
				});
			});
		},

		nextStep(step, document = null, additionalParams = {}) {
			if (document === null) {
				document = this.document;
			}

			this.$router.push({
				path: this.getBuilderUrl(document, step, additionalParams)
			});
		},

		getRouteStep(route) {
			return this.getObjectValue(
				"meta.step",
				this.$router.matcher.match(route)
			);
		},

		getStepMeta(
			step,
			metaValue = "",
			defaultValue = null,
			allowFalse = false
		) {
			metaValue = metaValue.toLowerCase();

			if (metaValue === "") {
				metaValue = "meta";
			}

			let route = this.steps.find(
				item => this.getObjectValue("meta.step", item) === step
			);

			if (route) {
				return this.getObjectValue(
					metaValue,
					route,
					defaultValue,
					allowFalse
				);
			}

			return undefined;
		},

		shouldBeDisabled(step, debug = false) {
			if (step === false) {
				return false;
			}

			if (!this.currentDocument) {
				return false;
			}

			// console.log([
			// 	(this.isProposal && step < this.getRouteStep(`/orders/${this.id}`)),
			// 	(!this.isProposal && step === this.getRouteStep(`/orders/${this.id}`)),
			// 	(this.isCreate && step > 1),
			// 	(!this.isCreate && this.currentDocument.step < step - 1)
			// ])

			if (
				(!this.isOrder &&
					step === this.getRouteStep(`/orders/${this.number}`)) ||
				(this.isOrder &&
					step !== this.getRouteStep(`/orders/${this.number}`))
			) {
				return true;
			}

			if (
				!this.isOrder &&
				this.getStepMeta(step, "meta.needs_line_items", false, true) &&
				this.getObjectValue("line_items", this.currentDocument, [])
					.length === 0
			) {
				return true;
			}

			return (
				(this.isOrder &&
					step < this.getRouteStep(`/orders/${this.number}`)) ||
				(!this.isOrder &&
					step === this.getRouteStep(`/orders/${this.number}`)) ||
				(this.isCreate && step > 1)
				//|| (!this.isCreate && this.currentDocument.step < step - 1)
			);
		}
	},

	beforeRouteLeave(to, from, next) {
		if (this.number === this.getObjectValue("params.number", to, null)) {
			if (this.preventStepUpdate) {
				return next();
			}

			let step = this.getObjectValue("meta.step", to, false);

			if (
				step === 1 &&
				this.getObjectValue("params.id", to, null) === "create"
			) {
				return next();
			}

			if (this.shouldBeDisabled(step)) {
				if (this.isOrder) {
					this.$swal({
						title: "Create a revision?",
						text:
							"This document is not editable. If you would like to edit it, you will need click the CREATE REVISION to make a copy.",
						type: "error",
						showCancelButton: true,
						confirmButtonText: "Create Revision"
					}).then(result => {
						if (result.value) {
							this.CREATE_REVISION({
								document_id: this.document.id
							}).then(data => {
								this.$nextTick(() => {
									next(
										this.getBuilderUrl(data.new_document, 1)
									);
								});
							});
						} else {
							return;
						}
					});
				}
				return;
			}

			if (step !== false) {
				if (
					!this.getObjectValue(
						"meta.needs_category",
						to,
						false,
						true
					) &&
					!this.getObjectValue("meta.needs_sku", to, false, true)
				) {
					let temp = this.UPDATE_DOCUMENT_STEP({
						document: this.document,
						step
					});

					temp.then(data => {
						next();
					});
				} else {
					next();
				}
			} else {
				// console.log('false', step);
				next();
			}
		} else {
			next();
		}
	}
};

module.exports.quoteBuilder = quoteBuilder;

module.exports.mainRoutes = {
	mixins: [quoteBuilder],

	created() {
		if (
			this.shouldBeDisabled(
				this.getObjectValue("meta.step", this.$route, false)
			)
		) {
			let path = "/dashboard";

			const keys = _.keys(this.steps);

			for (let i = parseInt(_.max(keys)); i > 0; i--) {
				if (!this.shouldBeDisabled(i, true)) {
					path = this.getBuilderUrl(this.currentDocument, i);
					break;
				}
			}

			this.$router.replace(path);
		}
	}
};
